import React from 'react'
import Tooltip from 'react-tooltip'

class Whitelist extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      idCollection: '',
      method: ''
    }
  }

  componentDidMount = () => {
    this.props.getWhitelist()
  }

  _forceReload = () => {
    this._clearAllArray()
    this.setState({ method: '' })
    this.props.getWhitelist()
  }

  _clearAllArray = () => {
    this.setState({ idCollection: '' })
  }

  _inputAllArray = (array) => {
    let idCollection = array.join(';')
    this.setState({ idCollection })
  }

  _onTextareaChange = (event) => {
    if (event) {
      event.preventDefault()
    }
    let idCollection = this.state.idCollection
    let value = event.target.value
    idCollection = value
    this.setState({ idCollection })
  }

  _arrayConvertNow = (string) => {
    let array = string.split(';').map(Number)
    return array
  }

  _handleMethod = (args) => {
    let value = args.target.value
    this.setState({ method: value })
  }

  _whitelistApiCall = (method) => {
    let data = { ids: this._arrayConvertNow(this.state.idCollection) }
    if (method === 'update') {
      this.props.putWhitelist(data)
    } else if (method === 'delete') {
      this.props.deleteWhitelist(data)
    }
    setTimeout(() => {
      this._forceReload()
    }, 300)
  }

  render () {
    const { cronReport } = this.props
    const { data_whitelist } = cronReport
    return (
      <section className='section' style={{ width: '55vw' }}>
        <header className='title-block'>
          <h1 className='title'>Manage Whitelist</h1>
        </header>
        <div className='form-group row'>
          <div className='col-3'>
            <label className='control-label'>
              Whitelisted ID
            </label>
          </div>
          <div className='col-9'>
            {
              data_whitelist.length > 0
                ? data_whitelist.map((item, i) => (
                  <span className='badge badge-info mr-2' key={i}>{item}</span>
                ))
                : <span className='badge badge-danger'>- No Whitelisted ID Yet -</span>
            }
          </div>
        </div>
        <div className='form-group row'>
          <div className='col-3'>
            <div className='row'>
              <label data-tip='Input multiple ID in this format: "ID;ID;ID;...". Please do not add space between ID and semicolons.' className='control-label'>
                Input ID
                <Tooltip />
                <i className='ml-2 fa fa-exclamation-circle' />
              </label>
            </div>
          </div>
          <div className='col-9'>
            <textarea rows={5} value={this.state.idCollection} onChange={(event) => this._onTextareaChange(event)} type='number' className='form-control' />
          </div>
        </div>
        <div className='form-group row'>
          <div className='col-12 text-right'>
            <button className='btn btn-danger mr-2' onClick={() => this._clearAllArray()}>Clear All</button>
            {
              data_whitelist.length !== 0 &&
              <button className='btn btn-primary' onClick={() => this._inputAllArray(data_whitelist.length > 0 && data_whitelist)}>Input All</button>
            }
          </div>
        </div>
        <div className='form-group row'>
          <div className='col-3'>
            <label className='control-label'>Select Action</label>
          </div>
          <div className='col-9'>
            <select required value={this.state.method} onChange={(event) => this._handleMethod(event)} className='form-control'>
              <option disabled value=''>- Please Select Action -</option>
              <option value='update'>Add Selected ID to Whitelist</option>
              <option value='delete'>Remove Selected ID from Whitelist</option>
            </select>
          </div>
        </div>
        <div className='row'>
          <div className='col-12 text-right'>
            <button className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
            <button onClick={() => this._whitelistApiCall(this.state.method)} className='btn btn-primary'>Apply</button>
          </div>
        </div>
      </section>
    )
  }
}

export default Whitelist



// WEBPACK FOOTER //
// ./src/Containers/CronReport/Whitelist.js